
 export  function formatTrendForApexChart(data) {
   const titleText=""
    const regions = data?.[0]?.region?.map((r) => r.region) || []; // Extract unique regions
    const categories = data?.map((d) => d.date); // Extract dates as categories
    const colors = ['#41B883', '#afafaf', '#57a850'];
    const series = regions?.map((region) => {
      return {
        name: region,
        data: data.map((d) => {
          const regionData = d.region.find((r) => r.region === region);
          return regionData ? regionData.count : 0;
        }),
      };
    });
  
    return {
      chart: {
        type: 'bar',
      },
      xaxis: {
        categories: categories,
      },
      series: series,
      
        chart: {
            height: 350,
            width: '100%',
            type: 'bar',
            stacked: true,
            stackType: '100%',
            events: {
                click: function (chart, w, e) {
                    // console.log(chart, w, e)
                },
            },
        },
        colors: colors,
        plotOptions: {
            bar: {
                columnWidth: '45%',
                distributed: false,
                // horizontal,
            },
        },
        stroke: {
            width: 1,
            colors: ['#fff'],
        },
        dataLabels: {
            enabled: true,
        },
        legend: {
            show: false,
        },
        xaxis: {
            categories:{
                categories: categories,
              },
            colors: ['#fff', '#afafaf', '#afafaf'],
            labels: {
                style: {
                    //colors: colors,
                    fontSize: '12px',
                },
            },
        },
        title: {
            text: titleText,
            floating: true,
            style: {
                color: 'navy',
            }
        },
    
    };
  }
  
  // Example usage:
  const trendData = [
    {
      "date": "2025-03-04",
      "region": [
        { "region": "SE", "count": 0 },
        { "region": "NC", "count": 1 },
        { "region": "NW", "count": 0 },
        { "region": "NE", "count": 0 },
      ],
    },
    {
      "date": "2025-03-05",
      "region": [
        { "region": "SE", "count": 0 },
        { "region": "NC", "count": 3 },
        { "region": "NW", "count": 0 },
        { "region": "NE", "count": 0 },
      ],
    },
  ];
  
  const apexChartOptions = formatTrendForApexChart(trendData);
  console.log(apexChartOptions);